export default {"src":"__ASTRO_ASSET_IMAGE__Dk6qM19f__","width":10,"height":18,"format":"svg"}